import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  ViewChild,
} from "@angular/core";
import { FormGroup } from "@angular/forms";
import {
  IonicPage,
  NavController,
  NavParams,
  ViewController,
} from "ionic-angular";
import * as _ from "lodash";
import { OrderDataService } from "../../../providers/order-data-service/order-data-service";
import { STANDING_ORDERS_CONFIG } from "./standing-orders-config";

/**
 * Generated class for the StandingOrderPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: "page-standing-order",
  templateUrl: "standing-orders.html",
})
export class StandingOrderPage {
  @ViewChild("orderForm") orderForm: ElementRef;

  captionAndVariables = STANDING_ORDERS_CONFIG.captionAndVariables;
  isFormvalid: any;
  view: boolean = false;
  templateData: object = {};
  /**
   * CO-3362: guards against a double Submit. The modal stays open until the
   * POST lands and the button was not disabled meanwhile, so a double-tap
   * created TWO standing-order templates — a duplicate version that then has to
   * be discontinued by hand from the physician panel.
   */
  submitting: boolean = false;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public viewCtrl: ViewController,
    private dataService: OrderDataService,
    private cdr: ChangeDetectorRef
  ) {
    if (navParams.data.view && navParams.data.template) {
      this.view = true;
      this.templateData = navParams.data.template;
    }
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

  onStandingOrderSubmit() {
    if (this.submitting) {
      return;
    }
    let soForm = this.orderForm["orderForm"];
    let postForm = this.getPostFormData(soForm);

    this.submitting = true;
    this.dataService.createStandingOrder(postForm).subscribe(
      (data) => {
        this.submitting = false;
        this.dataService.decreaseSpinnerCount();
        this.dataService.presentSuccessToast(
          `Standing order template created successfully!`
        );
        this.viewCtrl.dismiss({
          created: true,
        });
      },
      (err) => {
        // released on failure so the physician can correct and retry
        this.submitting = false;
        this.dataService.decreaseSpinnerCount();
        this.dataService.presentErrorToast(
          err,
          "Error creating standing order!"
        );
      }
    );
  }

  getPostFormData(soForm: FormGroup): Object {
    let postForm = {
      versionName: soForm.controls["soVersion"].value,
      subOrderConfig: {
        revision: 2,
        medication: [],
        dme: [],
        other: {},
      },
    };
    let dietOrder = {};
    let dietDesc = "";
    let activityDesc = "";
    let activityOrder = {};

    if (soForm.controls["monitorAndControlPainLevel"].value) {
      let medObj = this.getSelectedMedication(
        "Monitor And Control Pain Level",
        "dgMonitorAndControlPainLevelGrp",
        "dgMonitorAndControlPainLevel",
        "monitorAndControlPainLevel"
      );
      postForm.subOrderConfig.medication.push(medObj);
    }

    if (soForm.controls["anxietyDyspnea"].value) {
      let medObj = this.getSelectedMedication(
        "Anxiety/Dyspnea",
        "dganxietyDyspneaGrp",
        "dganxietyDyspnea",
        "anxietyDyspnea"
      );
      postForm.subOrderConfig.medication.push(medObj);
    }

    if (soForm.controls["otherMedication"].value) {
      for (let control of this.orderForm["orderForm"].get("dgotherMedGrp")[
        "controls"
      ]["dgotherMed"]["controls"]) {
        let medObj = {
          description: `Other Medications : ${control.controls["otherDescription"].value}`,
          medicines: [],
          selectedOptions: ["otherMedication"],
        };
        medObj.medicines.push({
          medicineId: control.controls["drugObject"].value.mediSpanId,
          name: control.controls["drugText"].value,
          hospicePayer: control.controls["isHospicePayer"].value,
          opioid: control.controls["isOpioid"].value,
        });
        postForm.subOrderConfig.medication.push(medObj);
      }
    }

    if (soForm.controls["prnChoice"].value) {
      let medObj = this.getSelectedMedication(
        "Laxative/Enema of choice PRN constipation / Impaction",
        "dgPrnChoiceGrp",
        "dgPrnChoice",
        "prnChoice"
      );
      postForm.subOrderConfig.medication.push(medObj);
    }

    if (soForm.controls["isPatRequest"].value) {
      for (let control of soForm.get("dgPatRequestGrp")["controls"][
        "dgPatRequest"
      ]["controls"]) {
        postForm.subOrderConfig.dme.push({
          description: "Foley Catheter PRN s/s of necention or pat/cg request",
          dmeType: control.controls["drugText"].value,
          hospicePayer: control.controls["isHospicePayer"].value,
          selectedOptions: [{ option: "isPatRequest" }],
        });
      }
    }

    if (soForm.controls["isDMEprovided"].value) {
      for (let control of soForm.get("dgDmeMedicineGrp")["controls"][
        "dgDmeMedicine"
      ]["controls"]) {
        postForm.subOrderConfig.dme.push({
          description: "DME to be provided",
          dmeType: control.controls["drugText"].value,
          hospicePayer: control.controls["isHospicePayer"].value,
          selectedOptions: [{ option: "isDMEprovided" }],
        });
      }
    }

    if (soForm.controls["oxygenBy"].value) {
      let medObj = {
        description: `Oxygen by ${soForm.controls["oxygenByValue"].value} at ${soForm.controls["oxygenAtValue"].value} litres per minute ${soForm.controls["oxygenPercentage"].value} for shortness of breath`,
        dmeType: soForm.controls["oxygenByDesc"].value,
        hospicePayer: soForm.controls["oxygenByHsp"].value,
        selectedOptions: [
          {
            option: "oxygenBy",
            oxygenByValue: soForm.controls["oxygenByValue"].value,
            oxygenAtValue: soForm.controls["oxygenAtValue"].value,
            oxygenPercentage: soForm.controls["oxygenPercentage"].value,
          },
        ],
      };
      postForm.subOrderConfig.dme.push(medObj);
    }

    dietOrder["selectedOptions"] = [];
    if (soForm.controls["asTolerated"].value) {
      dietDesc = `${dietDesc} As tolerated,`;
      dietOrder["selectedOptions"].push("asTolerated");
    }
    if (soForm.controls["tubeFeeding"].value) {
      dietDesc = `${dietDesc} tube feeding,`;
      dietOrder["selectedOptions"].push("tubeFeeding");
    }
    if (soForm.controls["typeRateSchedule"].value) {
      dietDesc = `${dietDesc} (type,rate,schedule) - ${soForm.controls["typeRateScheduleDesc"].value},`;
      dietOrder["selectedOptions"].push("typeRateSchedule");
      dietOrder["typeRateScheduleDesc"] =
        soForm.controls["typeRateScheduleDesc"].value;
    }
    if (soForm.controls["supplements"].value) {
      dietDesc = `${dietDesc} supplements - ${soForm.controls["supplementsDesc"].value}`;
      dietOrder["selectedOptions"].push("supplements");
      dietOrder["supplementsDesc"] = soForm.controls["supplementsDesc"].value;
    }
    dietOrder["hospicePayer"] = soForm.controls["dietOrderHsp"].value;
    dietOrder["description"] = dietDesc;
    dietOrder = _.isEmpty(dietOrder["selectedOptions"]) ? null : dietOrder;
    postForm.subOrderConfig.other["dietOrder"] = dietOrder;

    activityOrder["selectedOptions"] = [];
    if (soForm.controls["completeBedRest"].value) {
      activityDesc = `${activityDesc} Complete bedrest,`;
      activityOrder["selectedOptions"].push("completeBedRest");
    }
    if (soForm.controls["upAsTolerated"].value) {
      activityDesc = `${activityDesc} Up as tolerated,`;
      activityOrder["selectedOptions"].push("upAsTolerated");
    }
    if (soForm.controls["tarnsferBedChair"].value) {
      activityDesc = `${activityDesc} Transfer Bed/Chair,`;
      activityOrder["selectedOptions"].push("tarnsferBedChair");
    }
    if (soForm.controls["ambulanceWithAssist"].value) {
      activityDesc = `${activityDesc} Ambulance with assist `;
      activityOrder["selectedOptions"].push("ambulanceWithAssist");
    }
    activityOrder["hospicePayer"] = soForm.controls["activityOrderHsp"].value;
    activityOrder["description"] = activityDesc;
    activityOrder = _.isEmpty(activityOrder["selectedOptions"])
      ? null
      : activityOrder;
    postForm.subOrderConfig.other["activityOrder"] = activityOrder;

    let otherOrders = [];
    _.forEach(this.captionAndVariables, (ele) => {
      if (soForm.controls[ele.variableName].value) {
        let obj = {};
        (obj["name"] = ele.dbVarName),
          (obj["selectedOptions"] = [ele.variableName]),
          (obj["description"] =
            soForm.controls[ele.variableName + "Desc"].value),
          (obj["hospicePayer"] =
            soForm.controls[ele.variableName + "Hsp"].value);
        otherOrders.push(obj);
      }
    });
    for (let control of this.orderForm["orderForm"].get("dgotherGrp")[
      "controls"
    ]["dgother"]["controls"]) {
      otherOrders.push({
        name: "Other",
        selectedOptions: ["Other"],
        hospicePayer: control.controls["isHospicePayer"].value,
        description: control.controls["otherDescription"].value,
      });
    }
    postForm.subOrderConfig.other["otherOrders"] = otherOrders;
    return postForm;
  }

  getSelectedMedication(label, formGroup, formControl, selectedOpt) {
    let medObj = {
      description: label,
      medicines: [],
      selectedOptions: [selectedOpt],
    };
    for (let control of this.orderForm["orderForm"].get(formGroup)["controls"][
      formControl
    ]["controls"]) {
      medObj.medicines.push({
        medicineId: control.controls["drugObject"].value.mediSpanId,
        name: control.controls["drugText"].value,
        hospicePayer: control.controls["isHospicePayer"].value,
        opioid: control.controls["isOpioid"].value,
      });
    }
    return medObj;
  }

  validityChange(data) {
    this.isFormvalid = data.validity;
    this.cdr.detectChanges();
  }
}



// WEBPACK FOOTER //
// ./src/pages/orders/standing-orders/standing-orders.ts